import { CustomError } from 'ts-custom-error';

export class BaseError extends CustomError {
}
